import { Component } from 'utils/jsx'
import groupBy from 'utils/array-group-by'

import User from 'components/User'

export default class Day extends Component {
  beforeRender (props) {
    this.state = {
      title: props.moment.format('ddd DD MMM')
    }
  }
  template () {
    return (
      <div class='day'>
        <header class='day__header'>
          {this.state.title}
        </header>
        <div class='day__content' ref={this.ref('content')} />
      </div>
    )
  }

  afterRender (props) {
    const users = groupBy(props.events, 'user')

    if (!Object.values(users).length) {
      this.base.classList.add('is-empty')
    }

    for (const user in users) {
      this.render(<User name={user} events={users[user]} />, this.refs.content)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Day.js